
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91paxid_93O_45kuGRd6rzR29msyJcNiP9kPFS6xPtzEKNRMLXZ4SSEMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue?macro=true";
import { default as _91competitionname_93SjPOv_453MgbxaWnlp5_LtG4g4KgePFu9omxu_45Hi9t0uwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/competition/[competitionname].vue?macro=true";
import { default as _91id_93kwkBOe4I5PbxflbT0gQSVRhJnLDM0Qy9RAN6NFAwmgkMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-confirmation/[id].vue?macro=true";
import { default as _91tripname_93dgNdxm9mVgyAeM18_45YrBrwH_ZoG58R2cVnoM9BQ22qEMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/titinerary/[tripname].vue?macro=true";
import { default as _91ocr_93IohhnPbZUjwXDX4pxokEHKjSLeFVlKRmtpmdjDEgLSAMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-finish/[ocr].vue?macro=true";
import { default as _91tripid_93ewHr7187sNh7rG6AfcPwk9DpuU8pzLH56kXMB3uE9JAMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue?macro=true";
import { default as _91ocr_93gEUYtifZZlYzdJd3nSxT_45HNqdPibTAO6QpRlVsPPZ_cMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/bookingfaq/[ocr].vue?macro=true";
import { default as _91name_93KePT7wZoM65BIAq3W2yazW1xawEZWSn6LhZ3Me9f_YMMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/shipinfo/[name].vue?macro=true";
import { default as _91authpage_93ssWkJYelsW4PvSxMnDZlKBZ5PnyYYXsqWhtOkPzHYqIMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/auth/[authpage].vue?macro=true";
import { default as _91id_93MpEgabFYVTnCYrL8Yh7hxvObWBBC_pKeugN3aSgiBf8Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/payment/[id].vue?macro=true";
import { default as _91jwt_93K91AJAXr60NxCf9zu_45nthKSqxiQfLAu9ClcM2PLLzjoMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/app/l/[jwt].vue?macro=true";
import { default as _91id_93O2k3Cy6BpKgteCGsdzDVVw2v4uiAhULVzUhHClFtYO0Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/fn/[id].vue?macro=true";
import { default as faqxGDJ8M_45jEXcWJ5u6mg7lDJgkKWiAO_91Wq_UkS4NjSYMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/faq.vue?macro=true";
import { default as mapftLTiPmqO_3_sIlNZk1qVKdwtrzIpu6T5eEVQG9mcqAMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/map.vue?macro=true";
import { default as index0Jz12h3cKl1srrNFW9YKeweIFSwamkSO9FunFsMKKVkMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/index.vue?macro=true";
import { default as risroswqZRQOq_45YG1b4QCNNkI__VtfW3NtQ7wZLxCNwCldwhMMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/risros.vue?macro=true";
import { default as searchoqrv7E8rcg39ifoejGPbMRIp8s_45vVdHQ0ojIVCzgTmwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/search.vue?macro=true";
import { default as bookcalloi_JhbAA_45apUXMMMmQIVCggPDJSfbqerfvbKECiPw6YMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/bookcall.vue?macro=true";
import { default as byebyeiebrPu38a3AetKr6fR8DAyGs9x1123nSnQd0h8nftHQv8Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/byebyeie.vue?macro=true";
import { default as solresorFYpQlkaPAE2ozz9WfzxAXwYKZ2TIaSp4BcXicZMMq4AMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/solresor.vue?macro=true";
import { default as indexDFvQwh_45nHrKPmiVIl9HWDonmegJuUdy2RlnAOec8q7wMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/app/index.vue?macro=true";
import { default as blackweekumtgnPRpi2IRU2HzkzbIiKGn5IqiGNZ6GVvyk6X2K10Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/blackweek.vue?macro=true";
import { default as catalogue_4537WnbGLyLgho5gul9H6Qn_p_FUNDPKnlTJg47vRHOoMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/catalogue.vue?macro=true";
import { default as complaintV_45H_SQcuvOQhmHXDLOzg4ch9qyp2YfV8ofYbpPjcDQQMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/complaint.vue?macro=true";
import { default as index3_qNfNbfU2Ce0u0B_45Bwijf0FAPLnu4DZkkDs4zx2T_kMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/blog/index.vue?macro=true";
import { default as indexFVJ9zwKJS4X90lWoNhyRvHI62nHETegLEt5pSUw2zkwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/info/index.vue?macro=true";
import { default as lastminuteSjO5WWCCU_70fD_451O2i_45NhIbq3ID7X0FSgkWDLktATEMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/lastminute.vue?macro=true";
import { default as newsletteraPcvEnlexbrOjvUy_45OC67xJDpetgc4lmcitM0d5x3zkMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/newsletter.vue?macro=true";
import { default as indexsmJsIuWEBBZ5Mdj_4537QAz_8Dp_45XmyWZd7uvQcazbN20Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/event/index.vue?macro=true";
import { default as index79z5hLkEJ1JqHBZNFa1TYg8kGdVvdWPWh5COk3fwiNkMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotels/index.vue?macro=true";
import { default as reviewsvK2kLQ_3dtxOwINnOtU8paEj_wa6NWjl4McNff_c2h4Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/reviews.vue?macro=true";
import { default as indexPfNSh2f5503QmsxrYB46utl4VSRbk4KlzWnFqaqwliEMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/review/index.vue?macro=true";
import { default as callbackMN4aAm5f_45ZqXguV9BAT0vT5kTKcZEZJuFTIKSJ5AdF0Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/auth/callback.vue?macro=true";
import { default as indexY7SMdOJhfbrdxK4RjbkKdyunU6STNOmtQ4Kmt_Fq93cMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/flights/index.vue?macro=true";
import { default as _91id_93admwHCVUhmxHtc3rmF9NmNEJEMlu8cbceWGeBF13NBwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/giftcard/[id].vue?macro=true";
import { default as _91name_93pR9yVmzES4h1xW1rdUa_45Czr9QVwPoLR2Nawe6TCj_E4Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotels/[name].vue?macro=true";
import { default as owngroupZwMOauZ6POOd8_W_7cirgZy9bL_o0MI41nhH_ilhMGQMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/owngroup.vue?macro=true";
import { default as upcomingtripsjECwGahyDL_45K3MoMEb7aAs3DPbT54EvQuZDJXdU624oMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/upcomingtrips.vue?macro=true";
import { default as indexdL8mJUKGlR4xiI4K6vYZC4NE6PbN9NZKuZBltJlPXaQMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/calendar/index.vue?macro=true";
import { default as indexcrWo3UMqG8KTNUN5feIAy2Osqnn0aYh_458mJ2Efd5X_AMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/campaign/index.vue?macro=true";
import { default as searchA8gjZRaPgamW0LS_45rHDqLCenvEEQvvi_456hb_45y8T5eA4Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/flights/search.vue?macro=true";
import { default as indexwE1ts1qNYqL21OpcYrTmlLEWiKJMYz2mWhHn5DZFMC4Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/giftcard/index.vue?macro=true";
import { default as _91_91tab_93_93GHMtqh_45NbHGDCjCtYenK_OG9T8qATGBiA1bEU_45uRtEkMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/mytrip/[[tab]].vue?macro=true";
import { default as searchsDv03aO7UOw7NMfA3_jyht8MX6pbrpkv_F_453FckeawIMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/package/search.vue?macro=true";
import { default as failed_45bj7v_45gulNZZ1Q_45mXixAX1_45xJqy_453fYICP_xrKq2miwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/payment/failed.vue?macro=true";
import { default as _91postname_93mSNeR_45IG5dG8qVL1ZnwJtllCknTecDFJtVBt78jqDmgMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/blog/[postname].vue?macro=true";
import { default as searchmtEUm6DkZo_8KUW2plLcqjL5Vygpr1q9hDxGTVPD1tAMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/calendar/search.vue?macro=true";
import { default as _91name_93ygHkIz9TyuSUkClX12o1vD68zy3rDQshenGp5cNEvIMMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/campaign/[name].vue?macro=true";
import { default as _91pagename_93StMX69uingYVhyWcJIlxj8Ah0VPDgDk_LPOHfvyK8CYMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/info/[pagename].vue?macro=true";
import { default as personalcontactpgvWVFJYV7O2_W_KvUS4EFP400w3_45syY4nMRn6loZ9AMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/personalcontact.vue?macro=true";
import { default as grouptravelpypOFfy_bK07BgwiFji6r4tlDHGK2a0jLwQthqsuYD8Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/grouptravel.vue?macro=true";
import { default as indexlaDorkujyms_EEodbiMd9IUoMzcqVT1D0QmAT3leJEYMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/tourleader/index.vue?macro=true";
import { default as _91eventname_93IimN9a4o7G_457XeFjRHuUzxP98rs6g9oWSN11MPFbZiUMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/event/[eventname].vue?macro=true";
import { default as _91_91tab_93_93jocSjQeOR1enq8MN1Un6QBw0b93MtrhPANM7RXAO_45rYMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/solo/[[tab]].vue?macro=true";
import { default as verification_45done7kAojesdz_45EwJTf2T9dJ7yHJMcsZ57fDsF_45wXn_4566C4Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/verification-done.vue?macro=true";
import { default as _91_91tab_93_93Vth_2QIbTwXPs7Ms7VRQivUKSeueJ0rBzTglJDtnVUwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotel/[id]/[[tab]].vue?macro=true";
import { default as _91_91tab_93_938wulraD3p8Vl2qPEvUY9Z1ihZ0irB0gsVReOgh2mwXAMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/about/[[tab]].vue?macro=true";
import { default as _91_91tab_93_93QYuTTodbJ7opef96UFTGXmAN4oBJ6IYX0SI7mgmo3iAMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/package/[id]/[[tab]].vue?macro=true";
import { default as _91_91tab_93_93YoGrCPePXd_45zCzndsFINqc_45OnPCWvbJFLF_4520vtxXggMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/lectures/[[tab]].vue?macro=true";
import { default as _91_91step_93_93BtsIYFIQX_a4DRLtbQZj7WHhJ_45_45Mmf2V85FW2CkV1pMMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/book/[tripid]/[[step]].vue?macro=true";
import { default as _91_91tab_93_93KSBpA_45WjS3cisOcwLCLBYOaGlWCFRtM_45DyIOkBp_45l3oMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/tourleader/[id]/[[tab]].vue?macro=true";
import { default as _91_91tab_93_93AnpcvxhplaDTr1wWTi3r_45eFDF1XctxNFK2hU4FtvFS8Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/connections/[[tab]].vue?macro=true";
import { default as _91_91tab_93_93J_45gWpXj6IOgcdgVuU50e_45ktw_45mo3hFUbAB8RA6Yqex4Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/[triptype]/[tripname]/[[tab]].vue?macro=true";
import { default as _91_91view_93_938dki3byo4YQnWjpvuFIGFoCRI_djuERtvfoG37smxRsMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/category/[name]/[[tab]]/[[view]].vue?macro=true";
import { default as _91_91tab_93_935nDl6Xx8h_45sFM9F7h0DJw5cH8poNWfaxdMTQrQfzjq0Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/destination/[destinationname]/[[tab]].vue?macro=true";
import { default as component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta } from "/home/ubuntu/frontend-deploy/repo/continous/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A } from "/home/ubuntu/frontend-deploy/repo/continous/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "satisfactionstatus-triptypeid",
    path: "/satisfaction-status/:triptypeid()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "competition",
    path: "/competition",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/competition/[competitionname].vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking-confirmation",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "titinerary",
    path: "/itinerary",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/titinerary/[tripname].vue")
  },
  {
    name: "booking-finish",
    path: "/booking-finish",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "bookflight",
    path: "/bookflight",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "bookingfaq",
    path: "/boknings-faq",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "shipinfo",
    path: "/cruise",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "auth",
    path: "/member",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/auth/[authpage].vue")
  },
  {
    name: "payment",
    path: "/payment",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "app-l",
    path: "/app/l",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "fn",
    path: "/fn",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "faq",
    path: "/faq",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/faq.vue")
  },
  {
    name: "map",
    path: "/map",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/map.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index0Jz12h3cKl1srrNFW9YKeweIFSwamkSO9FunFsMKKVkMeta || {},
    alias: index0Jz12h3cKl1srrNFW9YKeweIFSwamkSO9FunFsMKKVkMeta?.alias || [],
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/index.vue")
  },
  {
    name: "risros",
    path: "/risros",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/risros.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/search.vue")
  },
  {
    name: "fn-id",
    path: "/fn/:id()",
    meta: _91id_93O2k3Cy6BpKgteCGsdzDVVw2v4uiAhULVzUhHClFtYO0Meta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "bookcall",
    path: "/book-call",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/bookcall.vue")
  },
  {
    name: "byebyeie",
    path: "/byebyeie",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/byebyeie.vue")
  },
  {
    name: "solresor",
    path: "/solresor",
    meta: solresorFYpQlkaPAE2ozz9WfzxAXwYKZ2TIaSp4BcXicZMMq4AMeta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/solresor.vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/app/index.vue")
  },
  {
    name: "blackweek",
    path: "/blackweek",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/blackweek.vue")
  },
  {
    name: "catalogue",
    path: "/catalogue",
    meta: { ...(catalogue_4537WnbGLyLgho5gul9H6Qn_p_FUNDPKnlTJg47vRHOoMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/catalogue.vue")
  },
  {
    name: "complaint",
    path: "/complaint",
    meta: { ...(complaintV_45H_SQcuvOQhmHXDLOzg4ch9qyp2YfV8ofYbpPjcDQQMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/complaint.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: { ...(index3_qNfNbfU2Ce0u0B_45Bwijf0FAPLnu4DZkkDs4zx2T_kMeta || {}), ...{"custom":true} },
    alias: ["/blog/list"],
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/blog/index.vue")
  },
  {
    name: "info",
    path: "/info",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/info/index.vue")
  },
  {
    name: "lastminute",
    path: "/lastminute",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/lastminute.vue")
  },
  {
    name: "newsletter",
    path: "/newsletter",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/newsletter.vue")
  },
  {
    name: "app-l-jwt",
    path: "/app/l/:jwt()",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "event",
    path: "/event",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/event/index.vue")
  },
  {
    name: "hotels",
    path: "/hotel",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotels/index.vue")
  },
  {
    name: "info-reviews",
    path: "/info/reviews",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/reviews.vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "review",
    path: "/evaluate-trip",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/review/index.vue")
  },
  {
    name: "auth-callback",
    path: "/member/callback",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/auth/callback.vue")
  },
  {
    name: "flights",
    path: "/flights",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/flights/index.vue")
  },
  {
    name: "giftcard-id",
    path: "/giftcard/:id()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/giftcard/[id].vue")
  },
  {
    name: "hotels-name",
    path: "/hotel/:name()",
    meta: { ...(_91name_93pR9yVmzES4h1xW1rdUa_45Czr9QVwPoLR2Nawe6TCj_E4Meta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotels/[name].vue")
  },
  {
    name: "info-owngroup",
    path: "/info/owngroup",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/owngroup.vue")
  },
  {
    name: "upcomingtrips",
    path: "/upcoming-trips",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/upcomingtrips.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    meta: { ...(indexdL8mJUKGlR4xiI4K6vYZC4NE6PbN9NZKuZBltJlPXaQMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/calendar/index.vue")
  },
  {
    name: "campaign",
    path: "/campaign",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/campaign/index.vue")
  },
  {
    name: "flights-search",
    path: "/flights/search",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/flights/search.vue")
  },
  {
    name: "giftcard",
    path: "/giftcard",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/giftcard/index.vue")
  },
  {
    name: "mytrip-tab",
    path: "/mytrip/:tab?",
    meta: { ...(_91_91tab_93_93GHMtqh_45NbHGDCjCtYenK_OG9T8qATGBiA1bEU_45uRtEkMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/mytrip/[[tab]].vue")
  },
  {
    name: "package-search",
    path: "/package/search",
    meta: searchsDv03aO7UOw7NMfA3_jyht8MX6pbrpkv_F_453FckeawIMeta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/package/search.vue")
  },
  {
    name: "payment-failed",
    path: "/payment/failed",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/payment/failed.vue")
  },
  {
    name: "auth-authpage",
    path: "/member/:authpage()",
    meta: { ...(_91authpage_93ssWkJYelsW4PvSxMnDZlKBZ5PnyYYXsqWhtOkPzHYqIMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/auth/[authpage].vue")
  },
  {
    name: "blog-postname",
    path: "/blog/:postname()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/blog/[postname].vue")
  },
  {
    name: "calendar-search",
    path: "/find-trip",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/calendar/search.vue")
  },
  {
    name: "campaign-name",
    path: "/campaign/:name()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/campaign/[name].vue")
  },
  {
    name: "info-pagename",
    path: "/info/:pagename()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/info/[pagename].vue")
  },
  {
    name: "personalcontact",
    path: "/personal-contact",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/personalcontact.vue")
  },
  {
    name: "shipinfo-name",
    path: "/cruise/:name()",
    meta: { ...(_91name_93KePT7wZoM65BIAq3W2yazW1xawEZWSn6LhZ3Me9f_YMMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "bookingfaq-ocr",
    path: "/boknings-faq/:ocr()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "info-grouptravel",
    path: "/info/grouptravel",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/grouptravel.vue")
  },
  {
    name: "tourleader",
    path: "/tourleader",
    meta: { ...(indexlaDorkujyms_EEodbiMd9IUoMzcqVT1D0QmAT3leJEYMeta || {}), ...{"custom":true} },
    alias: ["/tourleader/list"],
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/tourleader/index.vue")
  },
  {
    name: "event-eventname",
    path: "/event/:eventname()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/event/[eventname].vue")
  },
  {
    name: "info-solo-tab",
    path: "/info/solo/:tab?",
    meta: _91_91tab_93_93jocSjQeOR1enq8MN1Un6QBw0b93MtrhPANM7RXAO_45rYMeta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/solo/[[tab]].vue")
  },
  {
    name: "verification-done",
    path: "/verification-done",
    meta: verification_45done7kAojesdz_45EwJTf2T9dJ7yHJMcsZ57fDsF_45wXn_4566C4Meta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/verification-done.vue")
  },
  {
    name: "hotel-id-tab",
    path: "/hotell/:id()/:tab?",
    meta: { ...(_91_91tab_93_93Vth_2QIbTwXPs7Ms7VRQivUKSeueJ0rBzTglJDtnVUwMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotel/[id]/[[tab]].vue")
  },
  {
    name: "info-about-tab",
    path: "/info/about/:tab?",
    meta: { ...(_91_91tab_93_938wulraD3p8Vl2qPEvUY9Z1ihZ0irB0gsVReOgh2mwXAMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/about/[[tab]].vue")
  },
  {
    name: "bookflight-tripid",
    path: "/bookflight/:tripid()",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "booking-finish-ocr",
    path: "/booking-finish/:ocr()",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "package-id-tab",
    path: "/package/:id()/:tab?",
    meta: _91_91tab_93_93QYuTTodbJ7opef96UFTGXmAN4oBJ6IYX0SI7mgmo3iAMeta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/package/[id]/[[tab]].vue")
  },
  {
    name: "info-lectures-tab",
    path: "/info/lectures/:tab?",
    meta: { ...(_91_91tab_93_93YoGrCPePXd_45zCzndsFINqc_45OnPCWvbJFLF_4520vtxXggMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/lectures/[[tab]].vue")
  },
  {
    name: "titinerary-tripname",
    path: "/itinerary/:tripname()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/titinerary/[tripname].vue")
  },
  {
    name: "book-tripid-step",
    path: "/book/:tripid()/:step?",
    meta: { ...(_91_91step_93_93BtsIYFIQX_a4DRLtbQZj7WHhJ_45_45Mmf2V85FW2CkV1pMMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/book/[tripid]/[[step]].vue")
  },
  {
    name: "tourleader-id-tab",
    path: "/tourleader/:id()/:tab?",
    meta: { ...(_91_91tab_93_93KSBpA_45WjS3cisOcwLCLBYOaGlWCFRtM_45DyIOkBp_45l3oMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/tourleader/[id]/[[tab]].vue")
  },
  {
    name: "info-connections-tab",
    path: "/info/connections/:tab?",
    meta: { ...(_91_91tab_93_93AnpcvxhplaDTr1wWTi3r_45eFDF1XctxNFK2hU4FtvFS8Meta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/info/connections/[[tab]].vue")
  },
  {
    name: "booking-confirmation-id",
    path: "/booking-confirmation/:id()",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "triptype-tripname-tab",
    path: "/:triptype([a-zåäöøæ0-9A-F%][a-zåäöøæ0-9A-F%\\- _]{2,})/:tripname([a-zåäöøæü0-9A-F%][a-zåäöøæü0-9A-F%\\- _]{2,})/:tab([a-zåäöøæü0-9A-F%\\- _]+)?",
    meta: _91_91tab_93_93J_45gWpXj6IOgcdgVuU50e_45ktw_45mo3hFUbAB8RA6Yqex4Meta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/[triptype]/[tripname]/[[tab]].vue")
  },
  {
    name: "competition-competitionname",
    path: "/competition/:competitionname()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/competition/[competitionname].vue")
  },
  {
    name: "category-name-tab-view",
    path: "/category/:name()/:tab?/:view?",
    meta: { ...(_91_91view_93_938dki3byo4YQnWjpvuFIGFoCRI_djuERtvfoG37smxRsMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/category/[name]/[[tab]]/[[view]].vue")
  },
  {
    name: "destination-destinationname-tab",
    path: "/destination/:destinationname()/:tab?",
    meta: { ...(_91_91tab_93_935nDl6Xx8h_45sFM9F7h0DJw5cH8poNWfaxdMTQrQfzjq0Meta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/destination/[destinationname]/[[tab]].vue")
  },
  {
    name: "satisfactionstatus-triptypeid-paxid",
    path: "/satisfaction-status/:triptypeid()/:paxid()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-installd",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/alla-resor",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/julmarkandsresor",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sportlov",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sportlov/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sportlov/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/pasklov",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/pasklov/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/pasklov/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarlov",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarlov/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarlov/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/hostlov",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/hostlov/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/hostlov/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/charterresor",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/charterresor/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/charterresor/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/all-inclusive",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/all-inclusive/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/all-inclusive/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/kontakt",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/kontakt/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/kontakt/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss/arbeta-for-oss",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss/arbeta-for-oss/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss/arbeta-for-oss/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/egypten/all-inclusive",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/egypten/all-inclusive/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/egypten/all-inclusive/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/indonesien",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/indonesien/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/indonesien/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/la-palma",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/la-palma/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/la-palma/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/mallorca",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/mallorca/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/mallorca/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/teneriffa",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/teneriffa/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/teneriffa/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/gran-canaria",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/gran-canaria/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/gran-canaria/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/costa-de-almeria",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/costa-de-almeria/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/costa-de-almeria/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/azorerna",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/azorerna/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/azorerna/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/lissabon",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/lissabon/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/lissabon/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/porto",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/porto/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/porto/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien/rom",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien/rom/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien/rom/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/zakynthos",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/zakynthos/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/zakynthos/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/santorini",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/santorini/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/santorini/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/rundresor/centralamerika/kuba",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/rundresor/centralamerika/kuba/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/rundresor/centralamerika/kuba/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarresor",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarresor/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarresor/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/flygstol",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/flygstol/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/flygstol/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/golfresor",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/golfresor/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/golfresor/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/aktiv",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/aktiv/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/aktiv/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/Templates",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/Templates/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/Templates/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: "localized-blog",
    path: "/:locale(en)/blog/list",
    meta: { ...(index3_qNfNbfU2Ce0u0B_45Bwijf0FAPLnu4DZkkDs4zx2T_kMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/rolfsbuss-web/pages/blog/index.vue")
  },
  {
    name: "localized-tourleader",
    path: "/:locale(en)/tourleader/list",
    meta: { ...(indexlaDorkujyms_EEodbiMd9IUoMzcqVT1D0QmAT3leJEYMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/tourleader/index.vue")
  }
]